<template>
    <div ref="editor"></div>
</template>
<script>
import Quill from "quill";
import "quill/dist/quill.core.css";


export default {
    props: {
        modelValue: {
            type: String,
            default: "",
        },
        placeholderSend: {
            type: String,
            default: "",
        },

    },
    data() {
        return {
            editor: null,
            placeholder: this.$props.placeholderSend
        };
    },
    mounted() {
      

        this.editor = new Quill(this.$refs.editor, {
            modules: {
                toolbar: false
            },
            //theme: 'bubble',
            theme: "snow",
           
            placeholder: this.placeholder,
        });
       
        this.editor.enable(false);
    },

     methods: {
        updateText() {
            this.$emit("update-text", this.editor.getText() ? this.editor.root.innerHTML : "");
        },
        updateTextEditor(text) {
            this.editor.root.innerHTML = text;
        }

    },

   
};
</script>
<style>
.ql-editor {
    height: 250px;
    overflow: auto;
}

.ql-snow .ql-tooltip {
    z-index: 1;
    position: absolute;
}
</style>